import { DATE_FILTER_OPERATION } from '../filter/operation.js';

export const DROPDOWN_DATE_OPTIONS = [
    [DATE_FILTER_OPERATION.between.id],
    [DATE_FILTER_OPERATION.equals.id, DATE_FILTER_OPERATION.before.id, DATE_FILTER_OPERATION.after.id],
    [DATE_FILTER_OPERATION.tomorrow.id, DATE_FILTER_OPERATION.today.id, DATE_FILTER_OPERATION.yesterday.id],
    [DATE_FILTER_OPERATION.nextWeek.id, DATE_FILTER_OPERATION.thisWeek.id, DATE_FILTER_OPERATION.lastWeek.id],
    [DATE_FILTER_OPERATION.nextMonth.id, DATE_FILTER_OPERATION.thisMonth.id, DATE_FILTER_OPERATION.lastMonth.id],
    [DATE_FILTER_OPERATION.nextQuarter.id, DATE_FILTER_OPERATION.thisQuarter.id, DATE_FILTER_OPERATION.lastQuarter.id],
    [DATE_FILTER_OPERATION.nextYear.id, DATE_FILTER_OPERATION.thisYear.id, DATE_FILTER_OPERATION.lastYear.id],
    [DATE_FILTER_OPERATION.yearToDate.id],
] as const;
